<template>
    <div>
        <h1 class="display-heading">Prescriptions Orders</h1>
        <div class="card mb-3">
            <div class="card-header">Search Prescription</div>
            <div class="card-body">
                <data-filter ref="dataFilter" :filters="filters"
                    searchText="Search Prescription"
                    clearSearchText="Clear Search"
                    @filterSearch="getPrescriptions"
                    @filterReset="getPrescriptions">
                </data-filter>
            </div>
        </div>

        <div ref="tableSection">
            <div class="table-responsive">
                <table ref="listTable" class="table table-hover">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Created Date</th>
                            <th scope="col">Prescription Id</th>
                            <th scope="col">Description</th>
                            <th scope="col">Status</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-show="prescriptionList.length === 0">
                            <td :colspan="columnsCount" class="text-center font-italic">
                                {{isTableLoading ? "Loading Data": "No Data"}}
                            </td>
                        </tr>

                        <tr v-for="(prescription, index) in prescriptionList" :key="index">
                            <th scope="row">{{((pagination.currentPage - 1) *pagination.pageSize ) + index + 1}}</th>
                            <td>
                                {{prescription.createDate}}
                            </td>
                            <td>
                                {{prescription.shortId}}
                            </td>
                            <td>
                                <template v-if="prescription.isUploadedPrescription">Uploaded Prescription List</template>
                                <template v-else>
                                    Consultation with Doctor
                                </template>
                            </td>
                            <td>
                                <prescription-status :statusId="prescription.statusId"></prescription-status>
                            </td>
                            <td>
                                <pharmacy-prescription-action :statusId="prescription.statusId" :prescriptionId="prescription.prescriptionListId">
                                </pharmacy-prescription-action>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <pagination v-model="pagination.currentPage"
                    :totalPages="pagination.totalPages"
                    :scrollPosition="pagination.scrollPosition">
                </pagination>
            </div>
        </div>
    </div>
</template>

<script>
import dataFilter from '@/components/data-filter';
import pagination from '@/components/pagination';
import prescriptionStatus from '@/components/prescription-status';
import pharmacyPrescriptionAction from '@/components/prescription-action/pharmacy';
import { convertToUserReadableDate } from '@/utilities';
export default {
    'name': 'PharmacyNewPrescriptionList',
    'components': {
        dataFilter,
        prescriptionStatus,
        pharmacyPrescriptionAction,
        pagination
    },
    'computed': {
        currentPage () {
            return this.pagination.currentPage;
        }
    },
    'watch': {
        currentPage () {
            this.$nextTick(() => {
                this.$refs.dataFilter.filterSearch(false);
            });
        }
    },
    data () {
        return {
            'prescriptionList': [],
            'columnsCount': 1,
            'isTableLoading': true,
            'prescriptionStatus': [1, 1000],
            'filters': [
                {
                    'label': 'Patient Name',
                    'type': 'text',
                    'value': '',
                    'placeholder': 'Enter Patient Name',
                    'objectKey': 'pn'
                },
                {
                    'label': 'Patient IC Number',
                    'type': 'text',
                    'value': '',
                    'placeholder': 'Enter Patient IC Number',
                    'objectKey': 'pic'
                },
                {
                    'label': 'Prescription ID',
                    'type': 'text',
                    'value': '',
                    'placeholder': 'Enter Prescription ID',
                    'objectKey': 'pi'
                }
            ],
            'pagination': {
                'currentPage': 1,
                'totalPages': 0,
                'pageSize': 20,
                'scrollPosition': 0
            }
        };
    },
    mounted () {
        this.columnsCount = this.$refs.listTable.rows[0].cells.length;

        // initialize scroll position
        this.$nextTick(() => {
            this.pagination.scrollPosition = this.$refs.tableSection.getBoundingClientRect().top + window.scrollY - document.querySelector('.top-navigation').clientHeight;
        });

        this.$refs.dataFilter.filterSearch();
    },
    'methods': {
        getPrescriptions (data) {
            if (data.shouldResetPaging) {
                this.pagination.currentPage = 1;
            }

            let dataFilter = data.data;
            let patientName = dataFilter.find(f => f.objectKey === 'pn') ? dataFilter.find(f => f.objectKey === 'pn').value : '';
            let patientIc = dataFilter.find(f => f.objectKey === 'pic') ? dataFilter.find(f => f.objectKey === 'pic').value : '';
            let prescriptionId = dataFilter.find(f => f.objectKey === 'pi') ? dataFilter.find(f => f.objectKey === 'pi').value : '';

            this.axios.post('Prescription/PharmacyGetAll', {
                's': this.prescriptionStatus,
                'pn': patientName,
                'pic': patientIc,
                'pi': prescriptionId,
                'p': this.pagination.currentPage,
                'ps': this.pagination.pageSize
            }).then(({ data }) => {
                this.isTableLoading = false;
                let pagedResult = data.data;

                this.pagination.currentPage = pagedResult.p;
                this.pagination.totalPages = pagedResult.c;

                let list = pagedResult.l;
                this.prescriptionList = [];
                this.prescriptionList = list.map((prescription) => ({
                    'prescriptionListId': prescription.pli,
                    'shortId': prescription.plis,
                    'createDate': convertToUserReadableDate(prescription.cd),
                    'status': prescription.s,
                    'statusId': prescription.ps,
                    'consultationId': prescription.cid,
                    'isUploadedPrescription': prescription.iu
                }));
            }).catch(({
                response
            }) => {

            });
        }
    }
};

</script>

<style>

</style>
